import styled, { keyframes } from 'styled-components/macro'
import { backgroundColor, primaryColor, thirdColor, textColor } from '../../../styles'

export const clickWave = keyframes`
  from {
    box-shadow: 0 0 0 0 ${primaryColor};
  }
  to {
    box-shadow: 0 0 0 5px ${primaryColor}00;
  }
`

export const ButtonStyled = styled.button`
  padding: 0 20px;
  height: 50px;
  border: none;
  font-weight: bold;
  font-size: 14px;
  cursor: pointer;
  border-radius: 40px;
  will-change: box-shadow;
  user-select: none;

  &.large {
    width: 300px;
    @media (max-width: 500px) {
      width: 280px;
    }
  }

  &.clicked {
    animation: ${clickWave} 1250ms cubic-bezier(0.19, 1, 0.22, 1);
    animation-fill-mode: forwards;
  }

  &.primary {
    color: ${textColor};
    background: linear-gradient(0deg, #0023ff, #0023ff), #121e34;
    box-shadow: -10px -10px 20px rgba(8, 21, 45, 0.4), 5px 5px 15px rgba(5, 12, 27, 0.6);
  }

  &.secondary {
    color: ${primaryColor};
    background-color: initial;
    border: 1.5px solid ${primaryColor};
  }

  &.third {
    color: ${textColor};
    background-color: ${thirdColor};
    border: 1.5px solid #ffa766;
  }

  &.transparent {
    color: ${textColor};
    background-color: initial;
  }

  &.loading {
    pointer-events: none;
    opacity: 0.8;
  }

  &.floating {
    position: absolute;
    bottom: 20px;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
  }
`

export const ButtonText = styled.div`
  > div {
    text-align: center;
    margin: auto;
    display: inline-block;
    line-height: 24px;
    vertical-align: top;
  }
`

export const ButtonIcon = styled.svg`
  width: 24px;
  height: 24px;
  display: inline-block;
  vertical-align: sub;
  margin-left: 10px;

  &.primary {
    stroke: ${backgroundColor};
  }

  &.secondary {
    stroke: ${primaryColor};
  }

  &.third {
    stroke: ${thirdColor};
  }

  &.transparent {
    stroke: ${textColor};
  }
`

const turn = keyframes`
  100% {
      transform: rotate(360deg);
  }
`

export const ButtonLoadingIcon = styled.svg`
  width: 16px;
  height: 16px;
  margin-top: 4px;
  margin-left: 15px;
  vertical-align: sub;
  stroke: ${textColor};
  stroke-width: 1px;
  stroke-dashoffset: 94.248;
  stroke-dasharray: 47.124;
  animation: ${turn} 1.6s linear infinite forwards;

  &.primary {
    stroke: ${backgroundColor};
  }

  &.secondary {
    stroke: ${primaryColor};
  }

  &.transparent {
    stroke: ${textColor};
  }
`
